export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NewDate.vue?vue&type=template&id=7158a07f&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Agenda/NewDate.vue?vue&type=template&id=7158a07f&
// module id = 417
// module chunks = 0